export enum Events {
    TRIP_NOTIFICATIONS = 'tripNotification',
    STAGING_NOTIFICATIONS = 'stagingNotification',
    ONBOARDING_NOTIFICATIONS = 'onboardingNotification',
    DRIVER_LOCATION_UPDATE_GLOBAL = 'locationUpdateGlobal',
    CHAT_MESSAGE = 'chat:message',
    CHAT_READ = 'chat:read',
    TICKET_CREATED = 'ticket:created',
    TICKET_UPDATED = 'ticket:updated'
}
